import { INTEGRATIONS_ACTIONS, initialIntegrationsState } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').IntegrationsSlice} state
 * @param {import('./integrations.types'.IntegrationsAction)} action
 * @returns
 */
export function integrationsReducer(state = initialIntegrationsState, { type, payload }) {
  switch (type) {
    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_STATUS:
      return {
        ...state,
        featurebase: { ...state.featurebase, status: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_ERRORS:
      return {
        ...state,
        featurebase: { ...state.featurebase, errors: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_TASK:
      return {
        ...state,
        featurebase: { ...state.featurebase, tast: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_CHANGELOG:
      return {
        ...state,
        featurebase: { changelog: { ...state.featurebase.changelog, ...payload } }
      }

    case INTEGRATIONS_ACTIONS.FETCH_INTEGRATIONS:
      return {
        ...state,
        integrations: payload.integrations,
        integration_categories: payload.integration_categories
      }

    case INTEGRATIONS_ACTIONS.FETCH_INTEGRATION:
      return {
        ...state,
        integrationDetail: payload
      }

    case INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATION:
      return {
        ...state,
        agencyIntegrationDetail: payload
      }

    case INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATIONS:
      return {
        ...state,
        agencyIntegrations: payload
      }

    case INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATIONS_BY_INTEGRATION_ID:
      return {
        ...state,
        agencyIntegrationsByIntegrationId: payload
      }

    case INTEGRATIONS_ACTIONS.FETCH_PORTALS_FOR_INTEGRATION:
      let transformedPortals = []
      try {
        if (payload && typeof payload === 'object') {
          transformedPortals = Object.entries(payload).map(([clientName, portals]) => ({
            client_name: clientName,
            portals: Array.isArray(portals) ? portals : [],
            id: clientName
          }))
        }
      } catch (error) {
        console.error('Error transforming portals data:', error)
        transformedPortals = []
      }
      return {
        ...state,
        availablePortals: transformedPortals
      }

    case INTEGRATIONS_ACTIONS.SET_PORTALS_FOR_INTEGRATION:
      return {
        ...state,
        selectedPortals: payload
      }

    case INTEGRATIONS_ACTIONS.FETCH_ASSIGNED_PORTALS_FOR_INTEGRATION:
      return {
        ...state,
        assignedPortals: Array.isArray(payload) ? payload : []
      }

    case INTEGRATIONS_ACTIONS.FETCH_CLIENTS_FOR_INTEGRATION:
      return {
        ...state,
        availableClients: Array.isArray(payload) ? payload : []
      }

    case INTEGRATIONS_ACTIONS.FETCH_ASSIGNED_CLIENTS_FOR_INTEGRATION:
      return {
        ...state,
        assignedClients: Array.isArray(payload) ? payload : []
      }

    case INTEGRATIONS_ACTIONS.FETCH_PORTAL_INTEGRATIONS:
      return {
        ...state,
        portalIntegrations: {
          ...state.portalIntegrations,
          [payload.portalId]: payload.data
        }
      }

    case INTEGRATIONS_ACTIONS.FETCH_PORTAL_INTEGRATION:
      return {
        ...state,
        portalIntegrationDetail: payload
      }

    case INTEGRATIONS_ACTIONS.CREATE_PORTAL_INTEGRATION:
      return {
        ...state,
        portalIntegrationDetail: payload
      }

    case INTEGRATIONS_ACTIONS.UPDATE_PORTAL_INTEGRATION:
      return {
        ...state,
        portalIntegrationDetail: payload
      }

    case INTEGRATIONS_ACTIONS.CLEAR_AGENCY_INTEGRATION_DETAIL:
      return {
        ...state,
        agencyIntegrationDetail: null
      }

    default:
      return state
  }
}
